import React, { useState, useEffect } from 'react';
import { HelpCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const SupportButton = ({ isOpen: externalOpen, setIsOpen: setExternalOpen }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  
  // Use external state if provided, otherwise use internal state
  const isOpen = externalOpen !== undefined ? externalOpen : internalOpen;
  const setIsOpen = setExternalOpen || setInternalOpen;

  return (
    <>
      {/* Floating Help Button - positioned above "Made with Emergent" banner */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-20 right-6 z-50 w-14 h-14 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
        data-testid="support-fab"
        aria-label="Get Support"
      >
        <HelpCircle className="w-6 h-6 group-hover:scale-110 transition-transform" />
      </button>

      {/* Support Dialog */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-[600px] max-h-[90vh] p-0 overflow-hidden">
          <DialogHeader className="p-4 pb-0">
            <div className="flex items-center justify-between">
              <DialogTitle className="text-xl font-semibold">Contact Support</DialogTitle>
            </div>
          </DialogHeader>
          <div className="w-full h-[533px]">
            <iframe 
              className="airtable-embed" 
              src="https://airtable.com/embed/appgu4vCGKrf2630k/pagwbb6RgPWSYjdMa/form" 
              frameBorder="0" 
              width="100%" 
              height="100%" 
              style={{ background: 'transparent', border: 'none' }}
              title="Support Form"
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SupportButton;
